
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import regulationsApi from "@/api/regulations";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import baseUrl, {imageUrl} from "@/constants";

    const {regionData, CodeToText} = require("@/js/region/region");
    @Component({
        name: 'regulations-list',
        components: {SetTableColumns}
    })
    export default class MeasuringListV2 extends Vue {
        mode = "Country"; //Country 国家， Local 地方，Other 其他
        modeValue = "ALL";//ALL 所有,Examine 审核,Share 共享
        modeType = "WaitShare";//WaitShare 待共享 Share 已共享 WaitExamine 待审核 Examine 已审核
        private exportExcel: any;
        showForm = false;//查询条件隐藏展示
        load = false;//加载
        dataList = []; //数据列表
        tabCol = [];
        allSelected = [];//列表选中数据
        sysMeasuringEdit = false; //是否有审核权限
        sysMeasuringShare = false;
        sysMeasuringExamine = false;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        propParams = this.getPropParams();
        total = 0;
        listParam: IPage = {
            size: 200,
            current: 1,
        };

        changeModelType(){
            this.refresh();
        }
        getPropParams() {
            return {
                status: '',// 审核状态 0:待提交 1:未审核  2:已生效  3:未通过
                shareStatus: '', //共享状态
                title: '', //文件标题
                conditions: '',//文号条件
                agencyName: '',//行文机关
                writingDate: '',//行文日期
                writingDateEnd: '',//行文日期
            }
        }

        created() {
            this.haveRight();
            this.init();
        }

        activated() {
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            } else {
                this.init();
            }
            this.tableClearSelect();
        }

        getTitle() {
            if (this.mode === 'Country') {
                return '国家计量法规政策';
            } else if (this.mode === 'Local') {
                return '地方计量法规政策';
            } else if (this.mode === 'Other') {
                return '其他计量法规政策';
            }
        }

        reset() {
            this.propParams = this.getPropParams();
            this.refresh();
        }

        tableClearSelect() {
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if ($table) {
                $table.clearSelection();
            }
        }

        init() {
            const route = this.$route;
            const q = JSON.parse(JSON.stringify(route.query));
            if (q.size) {
                this.listParam.size = Number(q.size);
                this.listParam.current = Number(q.current);
            }
            this.mode = this.$route.params.mode
            this.modeValue = this.$route.params.modeValue;
            if(this.modeValue === 'Examine'){
                this.modeType = "WaitExamine";
            }else if(this.modeValue === 'Share'){
                this.modeType = "WaitShare";
            }

            this.loadData(null);
        }

        getTableColumns() {
            return "Regulations";
        }

        hasBtn(mode: string) {
            if (mode === 'Add') {
                return this.modeValue === 'ALL' && this.sysMeasuringEdit;
            } else if (mode === 'Excel' || mode === 'Look') {
                return true;
            } else if (mode === 'Release') {
                return this.modeValue === 'Share' && this.modeType === 'WaitShare' && this.sysMeasuringShare;
            } else if (mode === 'Recall') {
                return this.modeValue === 'Share' && this.modeType === 'Share' && this.sysMeasuringShare;
            } else if (mode === 'Examine') {
                return this.modeValue === 'Examine' && this.modeType === 'WaitExamine' && this.sysMeasuringExamine;
            } else if (mode === 'Edit') {
                return this.modeValue === 'ALL' && this.sysMeasuringEdit;
            } else if (mode === 'Submit') {
                return this.modeValue === 'ALL' && this.sysMeasuringEdit;
            } else if (mode === 'Del') {
                return this.modeValue === 'ALL' && this.sysMeasuringEdit;
            }
            return false;
        }

        loadData(callback: any) {
            this.tableClearSelect();
            const route = this.$route;
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q, this.listParam);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            const params = {
                mode: this.mode,
                modeValue: this.modeValue,
                modeType: this.modeType,
                ...this.listParam,
                ...this.propParams,
            } as any;
            this.load = true;
            let API = regulationsApi.page(params);
            API.then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.total = r.data.data.total;
                    this.dataList = rData;
                    if (callback) {
                        callback();
                    }
                    this.$nextTick(() => {
                        let $table = this.$refs.table as HTMLFormElement;
                        if ($table) {
                            $table.doLayout();
                        }
                        this.load = false;
                    })
                }
            });
        }

        indexMethod(index: any) {
            return (this.listParam.current - 1) * this.listParam.size + index + 1;
        }

        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(() => {
                let $table = this.$refs.table as HTMLFormElement;
                if ($table) {
                    $table.doLayout();
                }
            })
        }

        haveRight() {
            const right = this.$store.state.userRights;
            right.forEach((e: any) => {
                if(e.name == "reg_examine") {
                    this.sysMeasuringExamine = true;
                }
                if(e.name == "reg_edit"){
                    this.sysMeasuringEdit = true;
                }
                if(e.name == "reg_share"){
                    this.sysMeasuringShare = true;
                }
            })
        }

        toDetail(type: string) {
            const dataArr = this.allSelected as any;
            let id = 0;
            if (type != 'Add') {
                if (dataArr.length == 0) {
                    this.$message.error("请先勾选");
                    return;
                }
                if (type === 'Release' || type == "Recall") {
                    this.batchReleaseOrRecall(dataArr, type);
                    return;
                }

                if (type == 'Del') {
                    const data = dataArr.filter((d: any) => d.status.value === 2);
                    if (data.length > 0) {
                        const names = data.flatMap((e: any) => e.title).join(",");
                        this.$message.error("您选择的 【" + names + "】已通过，无法进行删除！");
                        return;
                    }
                    this.batchDelete(dataArr);
                    return;
                }

                if (dataArr.length > 1 && (type == 'Look' || type == 'Edit' || type == 'Examine')) {
                    this.$message.error("只能勾选一条");
                    return;
                }

                if (type == 'Submit') {
                    const data = dataArr.filter((d: any) => d.status.value === 2);
                    if (data.length > 0) {
                        const names = data.flatMap((e: any) => e.title).join(",");
                        this.$message.error("您选择的 【" + names + "】已通过，无法进行提交！");
                        return;
                    }
                }
                if (type == 'Submit') {
                    this.batchSubmit(dataArr);
                    return;
                }
                if (type == 'Edit') {
                    this.toEdit(dataArr[0], type);
                    return;
                }
                id = dataArr[0].id;
            }
            this.goDetail(type, id);
        }

        goDetail(type: string, id: number) {
            const firstRouterText = this.$route.path.split("/")[1];
            this.$router.push("/" + firstRouterText + "/detail/" + id + "/" + this.mode + "/" + type);
        }

        toEdit(data: any, type: string) {
            if (data.status.value === 2) {
                this.$confirm('您勾选的是审核“已通过”的法规政策，编辑并保存后需要重新提交审核，是否继续编辑？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    this.goDetail(type, data.id);
                });
            } else {
                this.goDetail(type, data.id);
            }
        }

        lookEnclosure(enclosure: string) {
            try {
                const fileList = JSON.parse(enclosure);
                this.handlePdfPreview(fileList[0]);
            } catch (e) {
                this.$message.warning("无附件");
            }
        }

        handlePdfPreview(file: any) {
            window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl, "") + "&name=" + file.name, '_blank');
        }

        batchDelete(dataArr: any) {
            this.$confirm('您勾选了:  ' + dataArr.length + '条法规政策，是否删除', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                regulationsApi.delete(dataArr.flatMap((e: any) => e.id).join(",")).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.loadData(null);
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

      batchReleaseOrRecall(dataArr: any, type: string) {
        const str = type == 'Release' ? '发布' : '撤回';
        this.$confirm('您勾选了:  ' + dataArr.length + '条法规政策，是否' + (str) + '？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          const loading = this.$loading({
            text: `正在${str}，请等待...`,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          regulationsApi.share(dataArr.flatMap((e: any) => e.id).join(","), (type === 'Release' ? 1 : 2)).then(r => {
            loading.close();
            if (r.data.result === 0) {
              this.$message.success((str) + "成功！");
              this.loadData(null);
            }
          })
        })
      }


        batchSubmit(dataArr: any) {
            this.$confirm('您勾选了' + dataArr.length + '条法规政策，是否提交审核？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                regulationsApi.examine(dataArr.flatMap((e: any) => e.id).join(","), 1).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("提交成功");
                        this.refresh();
                    }
                })
            })
        }

        refresh() {
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
            this.loadData(null);
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.loadData(null);
        }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }

        onExportExcel() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const listParam = JSON.parse(JSON.stringify(this.listParam));
            this.listParam.size = this.total;    //将表格长度变成数据总长度
            this.listParam.current = 1;          //显示第一页
            this.loadData(() => {
                this.exportExcel(() => {
                    this.listParam = listParam;    //表格长度还原
                    this.loadData(null);
                    loading.close();
                }, "法规政策.xlsx");
            });
        }

    }
